import React, { useState, useEffect } from "react";
import { EnvironmentConfig } from "../config/environmentConfig";
const managementBaseUrl = EnvironmentConfig.api.baseUrl;
function ViewClasses() {
  const [classList, setClassList] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);
  const [features, setFeatures] = useState([]);
  const [values, setValues] = useState([]);
  const [units, setUnits] = useState([]);
  const [showCodes, setShowCodes] = useState(false);
  const [showSymbols, setShowSymbols] = useState(false); // ✅ Ny toggle för symboler
  const [searchFeatureTerm, setSearchFeatureTerm] = useState("");
  const [showValueModal, setShowValueModal] = useState(false);
  const [showUnitModal, setShowUnitModal] = useState(false);
  const [showValueImageModal, setShowValueImageModal] = useState(false);
  const [activeFeature, setActiveFeature] = useState(null);
  const [selectedValueIds, setSelectedValueIds] = useState([]);
  const [valueSearchTerm, setValueSearchTerm] = useState("");
  const [unitSearchTerm, setUnitSearchTerm] = useState("");
  const [activeValueImage, setActiveValueImage] = useState(null);
  const [valuePage, setValuePage] = useState(1);
  const [showImageModal, setShowImageModal] = useState(false);
  const [activeImage, setActiveImage] = useState(null);
  const valuesPerPage = 20;

  // Hämta klasser och data
  useEffect(() => {
    const fetchClasses = async () => {
      const res = await fetch(`${managementBaseUrl}/classes?language=sv`);
      const data = await res.json();
      setClassList(data.results || []);
    };

    const fetchFeaturesValuesUnits = async () => {
      const fRes = await fetch(`${managementBaseUrl}/featuress`);
      const vRes = await fetch(`${managementBaseUrl}/values`);
      const uRes = await fetch(`${managementBaseUrl}/units`);
      setFeatures(await fRes.json());
      setValues(await vRes.json());
      setUnits(await uRes.json());
    };

    fetchClasses();
    fetchFeaturesValuesUnits();
  }, []);

  const handleClassSelect = (e) => {
    const clsId = e.target.value;
    const cls = classList.find((c) => c.classId === clsId);
    setSelectedClass(cls ? { ...cls } : null);
  };

  const toggleActive = (featureId) => {
    const updatedFeatures = selectedClass.includedFeatures.map((f) =>
      f.featureId === featureId ? { ...f, active: !f.active } : f
    );
    setSelectedClass({ ...selectedClass, includedFeatures: updatedFeatures });
  };

  const openValueModal = (feature) => {
    setActiveFeature(feature);
    setSelectedValueIds(feature.valueList || []);
    setShowValueModal(true);
    setValuePage(1);
  };

  const openUnitModal = (feature) => {
    setActiveFeature(feature);
    setShowUnitModal(true);
  };

  const showValueImage = (valueId) => {
    const val = values.find((v) => v.valueCode === valueId);
    if (val && val?.image) {
      setActiveValueImage(val?.image);
      setShowValueImageModal(true);
    }
  };

  const saveValuesToFeature = () => {
    const updatedFeatures = selectedClass.includedFeatures.map((f) =>
      f.featureId === activeFeature.featureId ? { ...f, valueList: [...selectedValueIds] } : f
    );
    setSelectedClass({ ...selectedClass, includedFeatures: updatedFeatures });
    setShowValueModal(false);
    setSelectedValueIds([]);
  };

  const setUnitForFeature = (unitId) => {
    const updatedFeatures = selectedClass.includedFeatures.map((f) =>
      f.featureId === activeFeature.featureId ? { ...f, unit: unitId } : f
    );
    setSelectedClass({ ...selectedClass, includedFeatures: updatedFeatures });
    setShowUnitModal(false);
  };

  const addFeatureToClass = (feature) => {
    const newFeature = {
      uniqueId: `${selectedClass.classId}_${feature.featureId}`,
      featureId: feature.featureId,
      classId: selectedClass.classId,
      type: feature.type,
      active: true,
      selectable: false,
      selectableOrder: null,
      unit: "",
      valueList: [],
    };
    setSelectedClass({
      ...selectedClass,
      includedFeatures: [...selectedClass.includedFeatures, newFeature],
    });
  };

  const removeFeatureFromClass = (featureId) => {
    const updatedFeatures = selectedClass.includedFeatures.filter((f) => f.featureId !== featureId);
    setSelectedClass({ ...selectedClass, includedFeatures: updatedFeatures });
  };

  const saveClass = async () => {
    try {
      const payload = {
        classId: selectedClass.classId,
        className: selectedClass.className,
        description: selectedClass.description,
        features: selectedClass.includedFeatures.map((f) => ({
          uniqueId: f.uniqueId,
          featureId: f.featureId,
          classId: f.classId,
          type: f.type,
          active: f.active,
          selectable: f.selectable,
          selectableOrder: f.selectableOrder,
          unit: f.unit,
          values: f.valueList || [], // Viktigt att skicka värden
        })),
      };

      const response = await fetch(`${managementBaseUrl}/classes`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Misslyckades att spara klassen");
      }

      const data = await response.json();
      console.log("Klass sparad:", data);
      alert("Klass och features sparade i Occtoo!");
    } catch (error) {
      console.error("Fel vid sparning:", error);
      alert("Fel vid sparning av klassen");
    }
  };

  const filteredFeatures = features.filter(
    (f) =>
      (f.name?.toLowerCase().includes(searchFeatureTerm.toLowerCase()) ||
        f.featureId?.toLowerCase().includes(searchFeatureTerm.toLowerCase())) &&
      !selectedClass?.includedFeatures?.some((sf) => sf.featureId === f.featureId)
  );

  const filteredValues = values.filter((v) =>
    v.displayName.toLowerCase().includes(valueSearchTerm.toLowerCase())
  );
  const totalValuePages = Math.ceil(filteredValues.length / valuesPerPage);
  const paginatedValues = filteredValues.slice(
    (valuePage - 1) * valuesPerPage,
    valuePage * valuesPerPage
  );

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Hantera Klasser</h2>

      {/* Dropdown för klassval */}
      <div className="mb-3">
        <select
          className="form-select"
          onChange={handleClassSelect}
          value={selectedClass?.classId || ""}
        >
          <option value="">Välj en klass</option>
          {classList.map((cls) => (
            <option key={cls.classId} value={cls.classId}>
              {cls.className} ({cls.classId})
            </option>
          ))}
        </select>
      </div>

      {!selectedClass ? (
        <p>Välj en klass för att redigera.</p>
      ) : (
        <div>
          {/* Redigera klassinfo */}
          <div className="mb-3">
            <label className="form-label">Klassnamn</label>
            <input
              className="form-control mb-2"
              value={selectedClass.className}
              onChange={(e) => setSelectedClass({ ...selectedClass, className: e.target.value })}
            />
            <label className="form-label">Beskrivning</label>
            <textarea
              className="form-control"
              rows="3"
              value={selectedClass.description}
              onChange={(e) => setSelectedClass({ ...selectedClass, description: e.target.value })}
            />
          </div>

          {/* Toggle för valueCode */}
          <div className="form-check mb-2">
            <input
              type="checkbox"
              className="form-check-input"
              checked={showCodes}
              onChange={() => setShowCodes(!showCodes)}
            />
            <label className="form-check-label">Visa Koder</label>
          </div>

          {/* ✅ Toggle för symboler */}
          <div className="form-check mb-3">
            <input
              type="checkbox"
              className="form-check-input"
              checked={showSymbols}
              onChange={() => setShowSymbols(!showSymbols)}
            />
            <label className="form-check-label">Visa symboler</label>
          </div>

          {/* Tabell med befintliga features */}
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>ID</th>
                <th>Namn</th>
                <th>Symbol</th>
                <th>Typ</th>
                <th>Valda värden</th>
                <th>Enhet</th>
                <th>Aktiv</th>
                <th>Åtgärder</th>
              </tr>
            </thead>
            <tbody>
              {selectedClass?.includedFeatures?.map((f) => {
                const fullFeature = features.find((feat) => feat.featureId === f.featureId);
                return (
                  <tr key={f.uniqueId} className={!f.active ? "table-secondary" : ""}>
                    <td>{f.featureId}</td>
                    <td>{fullFeature?.name || f.featureId}</td>
                    <td>
                      {fullFeature?.image && (
                        <img
                          src={fullFeature?.image}
                          alt=""
                          style={{ width: "30px", cursor: "pointer" }}
                          onClick={() => {
                            setActiveImage(fullFeature?.image);
                            setShowImageModal(true);
                          }}
                        />
                      )}
                    </td>
                    <td>{f.type}</td>
                    <td>
                      {f.valueList && f.valueList.length > 0
                        ? f.valueList.map((id) => {
                            const val = values.find((v) => v.valueCode === id);
                            return val ? (
                              <span
                                key={id}
                                style={{ cursor: "pointer", marginRight: "8px" }}
                                onClick={() => showValueImage(id)}
                              >
                                {showSymbols && val?.image ? (
                                  <img src={val?.image} alt="" style={{ width: "20px" }} />
                                ) : showCodes ? (
                                  `${val.displayName} (${val.valueCode})`
                                ) : (
                                  val.displayName
                                )}
                              </span>
                            ) : (
                              ""
                            );
                          })
                        : "-"}
                    </td>
                    <td>
                      {f.unit
                        ? (() => {
                            const u = units.find((u) => u.unitId === f.unit);
                            return u ? u.unit : "";
                          })()
                        : "-"}
                    </td>
                    <td>
                      <button
                        className={`btn btn-sm ${f.active ? "btn-success" : "btn-secondary"}`}
                        onClick={() => toggleActive(f.featureId)}
                      >
                        {f.active ? "Aktiv" : "Inaktiv"}
                      </button>
                    </td>
                    <td>
                      {f.active && (
                        <>
                          {f.type === "A" && (
                            <button
                              className="btn btn-sm btn-secondary me-1"
                              onClick={() => openValueModal(f)}
                            >
                              Värden
                            </button>
                          )}
                          {(f.type === "N" || f.type === "R") && (
                            <button
                              className="btn btn-sm btn-secondary me-1"
                              onClick={() => openUnitModal(f)}
                            >
                              Enhet
                            </button>
                          )}
                        </>
                      )}
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => removeFeatureFromClass(f.featureId)}
                      >
                        Ta bort
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {/* Spara Klass-knapp */}
          <button className="btn btn-dark mt-3" onClick={saveClass}>
            Spara klass
          </button>

          {/* Lägg till nya features */}
          <h5 className="mt-4">Lägg till ny attribut</h5>
          <input
            className="form-control mb-2"
            placeholder="Sök feature"
            value={searchFeatureTerm}
            onChange={(e) => setSearchFeatureTerm(e.target.value)}
          />
          <table className="table table-hover">
            <thead>
              <tr>
                <th>ID</th>
                <th>Namn</th>
                <th>Symbol</th>
                <th>Typ</th>
                <th>Beskrivning</th>
                <th>Åtgärd</th>
              </tr>
            </thead>
            <tbody>
              {filteredFeatures.map((feat) => (
                <tr key={feat.featureId}>
                  <td>{feat.featureId}</td>
                  <td>{feat.name}</td>
                  <td>
                    {feat.image && (
                      <img
                        src={feat?.image}
                        alt=""
                        style={{ width: "30px", cursor: "pointer" }}
                        onClick={() => {
                          setActiveImage(feat?.image);
                          setShowImageModal(true);
                        }}
                      />
                    )}
                  </td>
                  <td>{feat.type}</td>
                  <td>{feat.description || "-"}</td>
                  <td>
                    <button className="btn btn-sm btn-dark" onClick={() => addFeatureToClass(feat)}>
                      Lägg till
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal för värden */}
      {showValueModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Välj värden för {activeFeature?.featureId}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowValueModal(false)}
                ></button>
              </div>
              <div className="modal-body" style={{ maxHeight: "400px", overflowY: "auto" }}>
                <input
                  className="form-control mb-3"
                  placeholder="Sök värde"
                  value={valueSearchTerm}
                  onChange={(e) => setValueSearchTerm(e.target.value)}
                />
                <div className="row">
                  {paginatedValues.map((v) => (
                    <div key={v.valueCode} className="col-md-6 mb-2">
                      <div className="card p-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value={v.valueCode}
                            checked={selectedValueIds.includes(v.valueCode)}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setSelectedValueIds((prev) =>
                                checked
                                  ? [...prev, v.valueCode]
                                  : prev.filter((id) => id !== v.valueCode)
                              );
                            }}
                          />
                          <label className="form-check-label">
                            <strong>{v.displayName}</strong>
                            {showCodes && ` (${v.valueCode})`}
                          </label>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <nav className="mt-3">
                <ul className="pagination justify-content-center">
                  {[...Array(totalValuePages)].map((_, i) => (
                    <li key={i} className={`page-item ${valuePage === i + 1 ? "active" : ""}`}>
                      <button className="page-link" onClick={() => setValuePage(i + 1)}>
                        {i + 1}
                      </button>
                    </li>
                  ))}
                </ul>
              </nav>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowValueModal(false)}>
                  Avbryt
                </button>
                <button className="btn btn-dark" onClick={saveValuesToFeature}>
                  Spara
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal för enheter */}
      {showUnitModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Välj enhet för {activeFeature?.featureId}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowUnitModal(false)}
                ></button>
              </div>
              <div className="modal-body" style={{ maxHeight: "400px", overflowY: "auto" }}>
                <input
                  className="form-control mb-3"
                  placeholder="Sök enhet"
                  value={unitSearchTerm}
                  onChange={(e) => setUnitSearchTerm(e.target.value)}
                />
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>Enhet</th>
                      <th>Åtgärd</th>
                    </tr>
                  </thead>
                  <tbody>
                    {units
                      .filter((u) => u.unit.toLowerCase().includes(unitSearchTerm.toLowerCase()))
                      .map((u) => (
                        <tr key={u.unitId}>
                          <td>{u.unit}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-dark"
                              onClick={() => setUnitForFeature(u.unitId)}
                            >
                              Välj
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal för värdebild */}
      {showValueImageModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Symbol för värde</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowValueImageModal(false)}
                ></button>
              </div>
              <div className="modal-body text-center">
                <img src={activeValueImage} alt="Value Symbol" style={{ maxWidth: "100%" }} />
              </div>
            </div>
          </div>
        </div>
      )}

      {showImageModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Symbol</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowImageModal(false)}
                ></button>
              </div>
              <div className="modal-body text-center">
                <img src={activeImage} alt="Feature" style={{ maxWidth: "100%" }} />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ViewClasses;
